export const preorderStatus = ['A', 'P', 'C', 'H', 'R', 'X', 'N', 'E', 'D']

export const preorderOwners = ['me', 'all']

export const preorderClosingStatus = ['C', 'H', 'R']

export const preorderNotClosingStatus = ['A', 'H', 'P', 'D']

export type PreorderStatus = typeof preorderStatus[number]

export const preorderStatusToDescription = (type: PreorderStatus): string => {
  switch (type) {
    case 'A': return "active"
    case 'P': return "pendingApproval"
    case 'C': return "approved"
    case "H": return "holded"
    case 'R': return "refused"
    case 'N': return "notAvailable"
    case 'X': return "processed"
    case 'E': return "error"
    case 'D': return "derived"
  }
  return "not"
}

export type PreorderOwners = typeof preorderOwners[number]

export const preorderOwnersToDescription = (type: PreorderOwners): string => {
  switch (type) {
    case 'me': return "toMe"
    case 'all': return "toAll"
  }
  return "not"
}

export const statusPreorderNames: string[] = [
  "active", "pendingApproval", "approved", "holded", "refused", "notAvailable", "processed", "error", "derived"]


export const statusPreorderNameTranslated = (value: PreorderStatus, t: (key: string) => string) =>
  t(`${preorderStatusToDescription(value)}`)
